'use client';

import { useEffect, useState } from 'react';
import { readCostCalculationId } from '@paction-2.0/util/url';

const readSharedCalculationId = () =>
  readCostCalculationId(window.location.hash) ?? undefined;

export function useSharedCalculationId(): string | undefined {
  const [calculationId, setCalculationId] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    const syncFromHash = () => setCalculationId(readSharedCalculationId());
    syncFromHash();
    window.addEventListener('hashchange', syncFromHash);
    return () => window.removeEventListener('hashchange', syncFromHash);
  }, []);

  return calculationId;
}
